<script>
  import { onMount } from "svelte";
  import moment from "moment";
  import { ModalBody, ModalFooter, ModalHeader, Modal } from "sveltestrap";
  import backend from "../../../../../server";
  export let isNew = false;
  let isLoading = false;
  export let bonus = null;
  export let players = [];
 
  export let listCampaign
  let games = [
    { id: 93243, gameid: 'endorphina2_VikingsWay@ENDORPHINA' },
    { id: 93391, gameid: 'endorphina2_BigBrown@ENDORPHINA' },
    { id: 93413, gameid: 'endorphina2_CricketHeroes@ENDORPHINA' },
    { id: 93414, gameid: 'endorphina2_2022HitSlot@ENDORPHINA' }
  ];
 

  const closeModal = () => {
    isNew = false;
  };
  const saveFreeSpin = async () => {
    try {
      isLoading = true;
      let response = await backend.freespin.saveEndorphina(bonus);
      if (response.status) {
        closeModal();
        listCampaign();
      } else {
      
      }
    } catch (error) {
    } finally {
      isLoading = false;
    }
  };

  onMount(async () => {
    bonus.id = Date.now();
  });
</script>

<Modal isOpen={isNew} toggle={closeModal} size="xl">
  <ModalHeader toggle={closeModal}>CREAR CAMPANAS DE ENDORPHINA</ModalHeader>
  <ModalBody>
    <div class="freeSpin-modal">

      <label>
        Moneda (currency):
        <input
          class="form-control"
          type="text"
          bind:value={bonus.currency}
          maxlength="3"
          placeholder="Ej: EUR"
        />
        <span class="description">Código ISO de la moneda.</span>
      </label>

      <label>
        Expiración (expires):
        <input
          class="form-control"
          type="datetime-local"
          bind:value={bonus.expires}
          placeholder="Ej: 2024-12-31T23:59:59Z"
        />
        <span class="description">
          Fecha de expiración del bono, formato: AAAA-MM-DDThh:mm:ssZ. Si no se
          especifica, el bono nunca expira.
        </span>
      </label>

      <label>
        Juego (game):
        <select class="form-control" bind:value={bonus.game}>
          <option value="" disabled selected>Selecciona un juego</option>
          {#each games as game}
            <option value={game.gameid}>{game.gameid}</option>
          {/each}
        </select>
      
      
        <span class="description">
          ID del juego (contenido). Si no se especifica, se puede activar para
          cualquier juego que admita este tipo de bonos.
        </span>
      </label>

      <label>
        ID único (id):
        <input
          class="form-control"
          type="text"
          bind:value={bonus.id}
          maxlength="32"
          placeholder="Ej: bonus12345"
        />
        <span class="description">ID único del bono.</span>
      </label>

      <label>
        Nombre (name):
        <input
          class="form-control"
          type="text"
          bind:value={bonus.name}
          maxlength="32"
          placeholder="Ej: Bono de Bienvenida"
        />
        <span class="description"
          >Nombre del bono amigable para el usuario.</span
        >
      </label>

      <label>
        Node ID (nodeId):
        <input
          class="form-control"
          type="text"
          bind:value={bonus.nodeId}
          placeholder="Ej: 12345"
        />
        <span class="description"
          >Merchant UID, emitido por ENDORPHINA para esta integración
          particular.</span
        >
      </label>


      

      <label>
        Jugador (player):
        <select class="form-control" bind:value={bonus.player}>
          {#each players as player}
            <option value={player.username}>
              {player.username} - {player.user}
            </option>
          {/each}
        </select>
        <span class="description">
          Nombre del jugador (el jugador debe estar registrado en el sistema de Endorphina antes de la creación del bono).
        </span>
      </label>
      

      <label>
        Cantidad de giros (spins.amount):
        <input
          class="form-control"
          type="number"
          min="0"
          bind:value={bonus.spins.amount}
          placeholder="Ej: 10"
        />
        <span class="description">Número de FREE SPINS.</span>
      </label>

      <label>
        Apuesta total (spins.totalBet):
        <input
          class="form-control"
          type="number"
          min="0"
          bind:value={bonus.spins.totalBet}
          placeholder="Ej: 1000"
        />
        <span class="description"
          >Apuesta de juego por FREE SPIN en milésimas de unidades monetarias.</span
        >
      </label>
    </div>
  </ModalBody>
  <ModalFooter>
    <button
      class="btn btn-primary"
      on:click={saveFreeSpin}
      disabled={isLoading}
    >
      {#if isLoading}
        <span
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
        Cargando...
      {:else}
        Guardar
      {/if}
    </button>
  </ModalFooter>
</Modal>

<style>
  .freeSpin-modal {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1rem;
  }

  label {
    display: flex;
    flex-direction: column;
    font-weight: bold;
  }

  .description {
    font-style: italic;
    font-size: 0.8rem;
    color: gray;
  }
</style>
